<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'好友的播播间'"></div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>

    <div :class="'home-page-help-bbj ios-' + iosDevice">
      <div :class="'header header-' + headerStatus">{{headFriendCode}}的播播间</div>
      <div v-if="playShow !== true" class="register-page">
        <div>
          <div class="top-title"></div>
          <div class="bottom-register">
            <div class="pic"><img src="https://download4.qcplay.com/h5-images/active/servitor/bbj/pic_img.png"></div>
            <div class="btn" @click="openBtn()"></div>
            <div class="info"><p>登录代表您同意<strong>《使魔计划》给您送出好礼</strong></p></div>
          </div>
        </div>        
      </div>

      <div :class="'play-page-help play-page-' + playShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
          <div v-show="playShow">
            <div :class="'top-content content-' + headerStatus">
              <div class="info-cont">
                <div class="icon-l">
                  <i :class="'my-pic my-pic-' + roleNum"></i>
                  <dl>
                    <dt>{{headFriendCode}}</dt>
                    <dd>9999万观看</dd>
                  </dl>
                </div>
                <div class="icon-r">
                  <div class="pic-all">
                    <i :class="'pic-' + item" v-for="(item, index) in picArr" :key="index"></i>
                  </div>
                  <div class="gz-num">9999万+</div>
                </div>
              </div>
              <div class="det-cont">
                <div class="det-btn" @click="ruleShow = true"></div>
                <div class="r-cont">
                  <div class="species">金币余额：{{user_data.species_num}}</div>
                  <div class="number">本店库存：{{user_data.number}}</div>
                </div>
              </div>
            </div>

            <div class="centcer-content">
              <div class="scroll">
                <div class="help-photosphere">
                  <div class="species">{{user_data.new_pecies_num}}</div>
                  <div class="xx">
                    <ul>
                      <li :class="'li-' + item.id" v-for="(item, index) in starList" :key="index"></li>
                    </ul>
                  </div>
                  <div class="btn" @click="helpBuy()"></div>
                </div>
                <div class="lightning lightning-1"></div>
              </div>
              <div :class="'role-cont role-' + roleNum"><div></div></div>
            </div>

            <div class="bottom-content">
              <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutUp" :duration="{ enter: 1000 }">           
                <div class="add-room" v-show="intoRoomShow">{{headFriendCode}} 加入了直播间</div> 
              </transition>
              <div class="cover"></div>
              <div class="scroll-info">
                <vue-seamless-scroll 
                  :data="wechatInfoList"
                  :class-option="classOption"
                  class="scroll"
                >
                  <ul class="item">
                    <li v-for="(item, index) in wechatInfoList" :key="index">
                      <p>
                        <b>VIP</b>
                        <span class="name" v-text="item.title"></span>
                        <span>:</span>
                        <span class="describe" v-text="item.desc"></span>
                      </p>                  
                    </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
              <div class="help-nav">
                <a class="return-btn" @click="returnHome()" href="javascript:;" title="返回"></a>
                <a class="search-btn" @click="youZbjShow = true" href="javascript:;" title="搜索"></a>
                <a class="groups-btn" @click="qqGroups()" href="javascript:;" title="加群"></a>
              </div>
            </div>
          </div>
        </transition>

      </div>
    </div>

    <!-- 个人设置弹窗 -->
    <div class="help-set-popup popup_wrap" v-show="setShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="set-box popup_wrap-box" v-show="setShow">
          <div class="secret-order" v-show="secretOrderShow">
            <p><strong>密令: 星夜下舞动</strong> <span @click="onCopy('#clipboard-btn')" id="clipboard-btn" data-event="复制邀请链接"
            :data-clipboard-text="'星夜下舞动'">复制</span></p>
          </div>
          <div class="more-list">
            <ul>
              <li>
                <span class="name">电影级画质</span>
                <mt-switch @change="switchStatus(switchStatus1, 1, '没这种东西，别点了...', '电影级画质')" v-model="switchStatus1"></mt-switch>
              </li>
              <li>
                <span class="name">背景音乐</span>
                <mt-switch @change="switchStatus(switchStatus2, 2, '来不及做了，给你个密令吧', '背景音乐')" v-model="switchStatus2"></mt-switch>
              </li>
            </ul>
          </div>
          <div class="user-info">
            <span class="span-l">{{userInfo.role_name}}</span>
            <span class="span-r">服务器:{{ userInfo.server_name }}</span>
          </div>
        </div>
      </transition>      
      <div class="close-bg" @click="setShow = false"></div>
    </div>

    <!-- 规则弹窗 -->
    <div class="help-rule-popup popup_wrap" v-show="ruleShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="rule-box popup_wrap-box" v-show="ruleShow"></div>
      </transition>
      <div class="close-bg" @click="ruleShow = false"></div>
    </div>

    <!-- 前往他人直播间 -->
    <div class="friends-zbj-popup popup_wrap" v-show="youZbjShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="friends-zbj-box popup_wrap-box" v-show="youZbjShow">
          <div class="code-box"><p><label for=""><input type="text" v-model="otherCode" placeholder="请输入好友的播播间"></label></p></div>
          <a class="btn" @click="findCode()" href="javascript:;"></a>
          <a class="qq-btn" @click="qqGroups()" href="javascript:;"></a>
        </div>
      </transition>
      <div class="close-bg" @click="youZbjShow = false"></div>
    </div>

    <!-- 卷轴购买完成 -->
    <div class="help-purchase-completed-popup popup_wrap" v-show="purchaseShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="purchase-completed-box popup_wrap-box" v-show="purchaseShow">
          <div class="purchase-box"><p>恭喜您成功购买<strong> 魔法卷轴 * {{is_number}}</strong></p></div>
        </div>
      </transition>
      <div class="close-bg" @click="purchaseClose()"></div>
    </div>

    <!-- 卷轴购买弹窗 -->
    <div class="help-buy-popup popup_wrap" v-show="buyShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="buy-box popup_wrap-box" v-show="buyShow">
          <div class="product-info">
            <dl>
              <dt>
                <img src="https://download4.qcplay.com/h5-images/active/servitor/bbj/product_img.png">
              </dt>
              <dd>
                <h3><span>{{user_data.old_pecies_num}}金币</span><strong>立减{{user_data.old_pecies_num - user_data.new_pecies_num}}金币</strong></h3>
                <h4>惊爆价：<strong>{{user_data.new_pecies_num}}金币</strong></h4>
                <p>库存: {{user_data.number}}<span style="padding-left: 15px;">今日限购数: {{ user_buy_number }}</span></p>
              </dd>
            </dl>
          </div>
          <div class="product-quantity">
            <dl>
              <dt>总价：{{is_number * user_data.new_pecies_num}}金币</dt>
              <dd>
                <div>
                  <span @click="reduce()">-</span>
                  <b>{{ is_number }}</b>
                  <span @click="add()">+</span>
                </div>
                <strong @click="maxCount()">Max</strong>
              </dd>
            </dl>
          </div>
          <div class="btn" @click="goBuy()"></div>
        </div>
      </transition>
      <div class="close-bg" @click="closeBuy()"></div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>    
  </div>

</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import { Toast, Switch, Indicator } from 'mint-ui';
import Clipboard from 'clipboard';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import { onHelpGetInitDataAPI, buyAPI, findAPI } from '../api';
import { analysisParams, getRandomString, buriedLogger } from '@/utils/utils';
export default {
  name: 'servitor',
  components: {
    vueSeamlessScroll,
    Login,
    Os
  },
  data () {
    return {
      gameName: 'servitor',
      icon_img: 'https://download4.qcplay.com/qcgame-admin/d5vbe60gfZ7dbtVlmLhP8kgJTCVGP23t1WNkHm1g.png',
      downloadUrl: 'https://smjh.qingcigame.com/official/',
      qqGroupsUrl: 'https://static2.qcplay.com/qq_group_jump/index.html?game_id=25',
      shareLink: '',
      shareLinkHelp: '',
      // ios设备
      iosDevice: false,
      // 当前好友的code
      friendsCode: '',
      // 头部的好友code名称
      headFriendCode: '',
      // 头部标题显示
      headerStatus: false,
      // 登录页面显示
      playShow: false,
      // 设置弹窗
      setShow: false,
      // 全屏遮罩
      preventShow: false,
      // 规则
      ruleShow: false,
      // 密令是否显示
      secretOrderShow: false,
      // 开关1
      switchStatus1: false,
      // 开关2
      switchStatus2: false,
      // 开关点击次数
      switchChickNum: 1,
      // 别人的直播间
      youZbjShow: false,
      // 卷轴购买弹窗
      buyShow: false,
      // 卷轴购买弹窗
      purchaseShow: false,
      // 弹窗类型(1-2)
      insureType: 1,
      // 数量
      is_number: 1,
      // 个人购买最大值
      user_buy_number: 0,
      // 留言列表
      wechatInfoList: [],
      // 星星列表
      starList: [
        {id: 1},{id: 2},{id: 3},{id: 4},{id: 5},{id: 6},{id: 7},{id: 8}
      ],
      picArr: [],
      user_data: {
        my_name: '',
        // 金币剩余数量
        species_num: 0,
        // 原产品金币
        old_pecies_num: 100,
        // 最新产品金币价格
        new_pecies_num: 0,
        code: '',
        // 库存剩余数量
        number: ''
      },
      prop_info: {
        prop_id: '',
        title: ''
      },
      // 第几个角色
      roleNum: 1,
      classOption: {
        step: 0.2,
        hoverStop: false,
      },
      // 其他的的code
      otherCode: '',
      // 进入房间
      intoRoomShow: false
    };
  },
  created () {   
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();

    const params = analysisParams(window.location.href);    
    let str = decodeURIComponent(unescape(params.code.replace(/\\u/g, '%u')));
    let result = decodeURIComponent(str).replace(/\//g, "\\");
    this.friendsCode = unescape(result.replace(/\\u/g, "%u"));
    this.headFriendCode = this.friendsCode.substring(0, this.friendsCode.length-8);
    setTimeout(() => {
      onHelpGetInitDataAPI({code: this.friendsCode}).then(response => {
        if (Number(response.code) == 200) {
          this.activeInfoData(response.data.activity);
          this.initShareData(response.data.user_info);
        }
        if (Number(response.code) !== 200) {
          Toast({ message: response.message, duration: 1000, className: 'toasts' });
          this.initShareData(response.data.user_info);
          setTimeout(() => {
            window.location.href = this.shareLink;
          }, 500);
        }
        this.isWechat()
        this.onInitDataCallback(response);
        this.preloadingShow = false;
      });
    }, 500);
    // 埋点
    const bl = buriedLogger('servitor', 'bbj_help_page');
    this.logger = bl;

    // 随机生成头像
    this.randomPic();
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        if (!newValue.user_id) {
          this.osCancell();
          // TAG: 注销的时候
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          this.initShareData(newValue);
        }
      }
    },
    activeInfo: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue.number);
        console.log('oldValue', oldValue.number);
        if (!newValue.score || !newValue.code) {
          // TAG: 注销的时候
        } else if (
          newValue.score !== oldValue.score || 
          newValue.number !== oldValue.number || 
          newValue.code !== oldValue.code || 
          newValue.pool_info !== oldValue.pool_info
        ) {
          console.log('数据变更刷新' + newValue.score)
          // TAG: 数据渲染
          this.activeInfoData(newValue);
        }
      }
    },
  },
  methods: {
    activeInfoData (info) {
      this.playShow = true;
      this.isWechat();
      // 玩家直播间名称
      this.user_data.my_name = info.room_info;
      // 金币剩余数量
      this.user_data.species_num = info.score;
      // 当前最新价格
      this.user_data.new_pecies_num = info.room_price;
      // 当前玩家code(兑换道具使用)
      this.user_data.code = info.code;
      // 魔法卷轴数量
      this.user_data.number = info.number;
      // 滚动留言列表
      this.wechatInfoList = info.wechat_info;
      // 出现第几个动画角色带货(1-3)
      this.roleNum = info.pic_id;
      // 加入直播间
      this.intoRoomShow = true;
      // 个人购买最大值
      this.user_buy_number = info.user_buy_number;
      
      setTimeout(() => { this.intoRoomShow = false }, 3000);
    },
    initShareData (info) {  
      const { protocol, host } = window.location;
      this.shareLink = `${protocol}//${host}/servitor/bbj/enter${getRandomString()}`;
      this.shareLinkHelp = `${protocol}//${host}/servitor/bbj/help${getRandomString()}?code=`;
      setTimeout(() => {
        this.isSetShare('使魔计划 | 魔法播播间','我说一个数，来我播播间，福利全部带走！');
      }, 1000);
    },
    isWechat() {
      let nav_control = navigator.userAgent;
      let is_micromessenger = nav_control.toLowerCase().match(/MicroMessenger/i)=="micromessenger";
      if (nav_control.match(/(iPhone|iPod|ios)/i) && !is_micromessenger) {
        if(nav_control.toLowerCase().indexOf('qq') > -1){
          return
        }
        this.iosDevice = true;
        is_micromessenger ? this.headerStatus = false : this.headerStatus = true;
      }
    },
    randomPic() {
      while (this.picArr.length < 3) {
        var randomNum = Math.floor(Math.random() * 8) + 1;
        if (this.picArr.indexOf(randomNum) === -1) {
          this.picArr.push(randomNum);
        }
      }
    },
    // 打开直播
    openBtn() {
      // 是否登录
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
      this.$nextTick(() => {
        Indicator.open();
        setTimeout(() => {
          Indicator.close();
          this.playShow = true;
          onHelpGetInitDataAPI({code: this.friendsCode}).then(response => {
            if (Number(response.code) == 200) {
              this.activeInfoData(response.data.activity);
              this.initShareData(response.data.user_info);
            }
            this.onInitDataCallback(response);
            this.preloadingShow = false;
          });
        }, 1000);
      });      
    },    
    // 选择角色后
    selectCallback () {
      onHelpGetInitDataAPI({code: this.friendsCode}).then(response => {
        this.onInitDataCallback(response);
        this.osCancell();
      });
    },
    // 区组弹窗注销-相关参数复位
    osCancell () {
      // 关闭
      this.playShow = false;   
      this.otherCode = '';    
    },
    // TAG: 相关业务方法
    onInvite () {
      if (this.userInfo.role_id === undefined) {
        this.changeLoginPopup(true);
        return false;
      }
    },
    switchStatus(data, num, info, control) {
      if(data) {
        this.preventShow = true;
        Indicator.open();
        setTimeout(()=> {
          Indicator.close();
          if(num == 1) {
            this.onToast(info);
          } else {
            if(this.switchChickNum == 1) {
              this.switchChickNum = this.switchChickNum + 1;
              this.onToast(info);
            } else {
              this.onToast('这次真没了，别点了...');
            }
            this.secretOrderShow = true;
          }
          this.switchStatus1 = false;
          this.switchStatus2 = false;        
          this.preventShow = false;
          this.logger.sum('使魔魔法播播间H5活动_帮助页_点击设置中'+ control +'的switch次数');
        }, 2000)
      }
    },
    // 前往自己的直播间
    returnHome() {
      Indicator.open('返回我的直播间...');
      setTimeout(()=> {
        window.location.href = this.shareLink;
        Indicator.close();
        this.logger.sum('使魔魔法播播间H5活动_帮助页_返回自己的播播间');
      }, 2000);
    },
    // 减少
    reduce() {
      const num = this.is_number;
      if(num > 1) {
        this.is_number = num - 1
      }      
    },
    // 增加
    add() {
      const user_data = this.user_data;
      let num = this.is_number;
      const floor_num = Math.floor(user_data.species_num / user_data.new_pecies_num);
      if (user_data.number > 0) {
        if (this.is_number < floor_num && num < floor_num) {
          // 超过个人库存总量，按个人库存总量计算
          if(num >= this.user_buy_number) {
            this.is_number = this.user_buy_number;
            return
          }
          num += 1;
        }        
      } else {
        if(this.user_buy_number > 0) {
          num += 1;
        }
      }
      this.is_number = num;
    },
    // 点击最大按钮
    maxCount() {
      var user_data = this.user_data;
      var floor_num = Math.floor(user_data.species_num / user_data.new_pecies_num);
      if(user_data.number < 1 || this.user_data.species_num < 1) return
      // 最小数量为1
      if(floor_num < 1) {
        this.is_number = 1;
        return
      }
      // 超过个人库存总量，按个人库存总量计算
      if(floor_num > this.user_buy_number) {
        this.is_number = this.user_buy_number;
        return
      }
      this.is_number = floor_num;
    },
    // 关闭购买弹窗
    closeBuy() {
      this.is_number = 1;
      this.buyShow = false;
    },
    // 前往购买
    goBuy() {
      if(this.is_number > this.user_data.number) {
        Toast({ message: '非常抱歉,当前商品库存不足!', duration: 1000, className: 'toasts' });
        return
      }
      Indicator.open();
      this.preventShow = true;
      buyAPI({number: this.is_number, code: this.friendsCode}).then(response => {
        setTimeout(()=> {
          if (Number(response.code) == 200) {
            this.purchaseShow = true;
            this.buyShow = false;
            onHelpGetInitDataAPI({code: this.friendsCode}).then(response => {
              this.onInitDataCallback(response);
            });
            this.logger.sum('使魔魔法播播间H5活动_帮助页_购买魔法卷轴');
          }
          if (Number(response.code) !== 200) {
            Toast({ message: response.message, duration: 1000, className: 'toasts' });
          }
          this.preventShow = false;
          Indicator.close();
        }, 1000);
      });
    },
    purchaseClose() {
      this.is_number = 1;
      this.purchaseShow = '';
    },
    // 复制链接
    onCopy (my_id) {
      const clipboard = new Clipboard(my_id);
      clipboard.on('success', (e) => {
        Toast({ message: '复制成功', duration: 1000, className: 'toasts' });
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        Toast({ message: '复制失败', duration: 1000, className: 'toasts' });
      });
      this.logger.sum('使魔魔法播播间H5活动_帮助页_复制密令按钮');
    },
    // 查询直播间
    findCode() {
      if( this.otherCode == '') {
        Toast({ message: '请您输入好友的直播间!', duration: 1000, className: 'toasts' });
        return
      }
      Indicator.open();
      this.preventShow = true;
      // 奖励领取API
      findAPI({code: this.otherCode}).then(response => {
        setTimeout(()=> {
          this.logger.sum('使魔魔法播播间H5活动_帮助页_查询直播间code码');
          if (Number(response.code) == 200) {
            window.location.href = this.shareLinkHelp + this.toUnicode(this.otherCode);
          }
          Toast({ message: response.message, duration: 1000, className: 'toasts' });
          this.preventShow = false;
          Indicator.close();
        }, 500);
      });
    },
    // TODO: 登陆弹窗demo
    openLoginOS () {
      if (this.userInfo.role_id) {
        this.setShow = false;
        this.changeOsPopup(true);
      } else {
        this.changeLoginPopup(true);
      }
    },
    // 分享发生
    isSetShare(is_title, is_desc) {
      this.setShare({ 
        title: is_title,
        desc: is_desc,
        imgUrl: this.icon_img,
        link: this.shareLink
      });
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },    
    toUnicode(str) {
      var res = [];
      for (var i = 0; i < str.length; i++) {
        res[i] = ( "00" + str.charCodeAt(i).toString(16) ).slice(-4);
      }
      return "/u" + res.join("/u");
    },
    helpBuy() {
      if(this.user_buy_number < 1 || this.user_data.species_num < 1) this.is_number = 0; 
      this.buyShow = true;
    },
    // 前往加群
    qqGroups() {
      this.preventShow = true;
      Indicator.open();
      this.logger.sum('使魔魔法播播间H5活动_帮助页_前往一键加群');
      setTimeout(()=> {
        this.preventShow = false;
        Indicator.close();
        window.location.href = this.qqGroupsUrl;
      }, 500);
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setActiveInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  }
};
</script>

<style lang="less" scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/servitor/bbj/help/index.vue